import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, RESERVATION_ROOM_ALL, RESERVATION_ROOM_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const RESERVATION_ROOM = GLOBAL_STATE

const reservationRoomSlice = createSlice({
  name: RESERVATION_ROOM,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.reservationRoomAll.pending, state => {
        state[RESERVATION_ROOM_ALL].loading = true
      })
      .addCase(actionCreators.reservationRoomAll.rejected, (state, action) => {
        state[RESERVATION_ROOM_ALL].loading = false
        state[RESERVATION_ROOM_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.reservationRoomAll.fulfilled, (state, action) => {
        state[RESERVATION_ROOM_ALL].loading = false
        state[RESERVATION_ROOM_ALL].error = null
        state[RESERVATION_ROOM_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.reservationRoomList.pending, state => {
        state[RESERVATION_ROOM_LIST].loading = true
      })
      .addCase(actionCreators.reservationRoomList.rejected, (state, action) => {
        state[RESERVATION_ROOM_LIST].loading = false
        state[RESERVATION_ROOM_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.reservationRoomList.fulfilled, (state, action) => {
        state[RESERVATION_ROOM_LIST].loading = false
        state[RESERVATION_ROOM_LIST].error = null
        state[RESERVATION_ROOM_LIST].data = action.payload
      })

    builder.addCase(actionCreators.reservationRoomAllClear, state => {
      state[RESERVATION_ROOM_ALL] = defaultState()
    })

    builder.addCase(actionCreators.reservationRoomListClear, state => {
      state[RESERVATION_ROOM_LIST] = defaultState()
    })
  },
})

export const { reducer: reservationRoomReducer } = reservationRoomSlice
